export enum TranslationKeyType {
  Unknown = 0,
  Web = 1,
  Backend = 2,
}
